import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=1d0db2c6&scoped=true"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=1d0db2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0db2c6",
  null
  
)

export default component.exports